import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, cleanup, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

afterEach(cleanup);

const m_institution = 
{
  id: 1,
  is_interview_unification: true
}

describe('Index', () => {
  describe('display revisited patient', () => {
    test('renders expected content', () => {
      const dInterviewDetails = [
        {
          id: 1,
          m_patient_id: 1,
          status: 3,
          kanzyano: "A12345",
          d_sheet_id: 1,
          name: "テスト太郎",
          is_new_patient: false,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date(),
          start_at: new Date(),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1,
          template_name: "男性"
        }
      ]

      const allDInterviewDetails = [
        {
          id: 1,
          m_patient_id: 1,
          status: 3,
          kanzyano: "A12345",
          d_sheet_id: 1,
          name: "テスト太郎",
          is_new_patient: false,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date(),
          start_at: new Date(),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1,
          template_name: "男性"
        }
      ]

      render(<Index d_interview_details={dInterviewDetails} all_d_interview_details={allDInterviewDetails} m_institution={m_institution}/>);

      // screen.debug();

      expect(screen.getByText("男性")).toBeInTheDocument();
      expect(screen.getAllByText("連携待ち")[1]).toHaveTextContent("連携待ち");
      expect(screen.getByText("A12345")).toBeInTheDocument();
    });
  });

  describe('display new patient', () => {
    test('renders expected content', () => {
      const dInterviewDetails = [
        {
          id: 1,
          m_patient_id: null,
          status: 1,
          kanzyano: "",
          d_sheet_id: 1,
          name: "テスト太郎",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date(),
          start_at: new Date(),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        }
      ]

      const allDInterviewDetails = [
        {
          id: 1,
          m_patient_id: null,
          status: 1,
          kanzyano: "",
          d_sheet_id: 1,
          name: "テスト太郎",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date(),
          start_at: new Date(),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        }
      ]
      render(<Index d_interview_details={dInterviewDetails} all_d_interview_details={allDInterviewDetails} m_institution={m_institution}/>);

      // screen.debug();

      expect(screen.getByText("紐づけ")).toBeInTheDocument();
      expect(screen.getAllByText("入力済み")[1]).toHaveTextContent("入力済み");
    });
  });

  describe('status-filter works', () => {
    test('renders expected content', () => {
      // 初めにレンダリングされる段階ではrails側でソートするので、その順番に合わせたものを用意
      const dInterviewDetails = [
        { // 入力中患者1人目
          id: 1,
          m_patient_id: null,
          status: 2,
          kanzyano: "",
          d_sheet_id: 1,
          name: "入力中テスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        }, 
        { // 入力中患者2人目
          id: 2,
          m_patient_id: null,
          status: 2,
          kanzyano: "",
          d_sheet_id: 2,
          name: "入力中テスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 入力済み患者1人目
          id: 3,
          m_patient_id: null,
          status: 1,
          kanzyano: "",
          d_sheet_id: 3,
          name: "入力済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 入力済み患者2人目
          id: 4,
          m_patient_id: null,
          status: 1,
          kanzyano: "",
          d_sheet_id: 4,
          name: "入力済みテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携待ち患者1人目
          id: 5,
          m_patient_id: 1,
          status: 3,
          kanzyano: "A12345",
          d_sheet_id: 5,
          name: "連携待ちテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携待ち患者2人目
          id: 6,
          m_patient_id: 2,
          status: 3,
          kanzyano: "B12345",
          d_sheet_id: 6,
          name: "連携待ちテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携済み患者1人目
          id: 7,
          m_patient_id: 3,
          status: 4,
          kanzyano: "C12345",
          d_sheet_id: 7,
          name: "連携済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携済み患者2人目
          id: 8,
          m_patient_id: 4,
          status: 4,
          kanzyano: "D12345",
          d_sheet_id: 8,
          name: "連携済みテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 送信済み患者1人目
          id: 9,
          m_patient_id: null,
          status: 0,
          kanzyano: "",
          d_sheet_id: 9,
          name: "送信済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: null,
          is_leftover_medicine: null,
          is_question: null,
          display_flg: 1
        },
        { // 送信済み患者2人目
          id: 10,
          m_patient_id: null,
          status: 0,
          kanzyano: "",
          d_sheet_id: 10,
          name: "送信済みテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: null,
          is_leftover_medicine: null,
          is_question: null,
          display_flg: 1
        }
      ]

      const allDInterviewDetails  = [
        { // 入力中患者1人目
          id: 1,
          m_patient_id: null,
          status: 2,
          kanzyano: "",
          d_sheet_id: 1,
          name: "入力中テスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        }, 
        { // 入力中患者2人目
          id: 2,
          m_patient_id: null,
          status: 2,
          kanzyano: "",
          d_sheet_id: 2,
          name: "入力中テスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 入力済み患者1人目
          id: 3,
          m_patient_id: null,
          status: 1,
          kanzyano: "",
          d_sheet_id: 3,
          name: "入力済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 入力済み患者2人目
          id: 4,
          m_patient_id: null,
          status: 1,
          kanzyano: "",
          d_sheet_id: 4,
          name: "入力済みテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携待ち患者1人目
          id: 5,
          m_patient_id: 1,
          status: 3,
          kanzyano: "A12345",
          d_sheet_id: 5,
          name: "連携待ちテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携待ち患者2人目
          id: 6,
          m_patient_id: 2,
          status: 3,
          kanzyano: "B12345",
          d_sheet_id: 6,
          name: "連携待ちテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携済み患者1人目
          id: 7,
          m_patient_id: 3,
          status: 4,
          kanzyano: "C12345",
          d_sheet_id: 7,
          name: "連携済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携済み患者2人目
          id: 8,
          m_patient_id: 4,
          status: 4,
          kanzyano: "D12345",
          d_sheet_id: 8,
          name: "連携済みテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 送信済み患者1人目
          id: 9,
          m_patient_id: null,
          status: 0,
          kanzyano: "",
          d_sheet_id: 9,
          name: "送信済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: null,
          is_leftover_medicine: null,
          is_question: null,
          display_flg: 1
        },
        { // 送信済み患者2人目
          id: 10,
          m_patient_id: null,
          status: 0,
          kanzyano: "",
          d_sheet_id: 10,
          name: "送信済みテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: null,
          is_leftover_medicine: null,
          is_question: null,
          display_flg: 1
        }
      ]
      const { container } = render(<Index d_interview_details={dInterviewDetails} all_d_interview_details={allDInterviewDetails} m_institution={m_institution}/>);

      // screen.debug();

      // フィルターをする前にデータがあることを確認
      expect(screen.getByText('入力中テスト')).toBeInTheDocument();
      expect(screen.getByText('入力中テスト2')).toBeInTheDocument();
      expect(screen.getByText('入力済みテスト')).toBeInTheDocument();
      expect(screen.getByText('入力済みテスト2')).toBeInTheDocument();
      expect(screen.getByText('連携待ちテスト')).toBeInTheDocument();
      expect(screen.getByText('連携待ちテスト2')).toBeInTheDocument();
      expect(screen.getByText('連携済みテスト')).toBeInTheDocument();
      expect(screen.getByText('連携済みテスト2')).toBeInTheDocument();
      expect(screen.getByText('送信済みテスト')).toBeInTheDocument();
      expect(screen.getByText('送信済みテスト2')).toBeInTheDocument();

      // 送信済みをフィルター
      const alreadyHandedCheckbox = screen.getByRole('checkbox', { name: '送信済み' }) as HTMLInputElement;
      fireEvent.click(alreadyHandedCheckbox);
      expect(alreadyHandedCheckbox.checked).toBe(false);
      expect(screen.queryByText("送信済みテスト")).not.toBeInTheDocument();
      expect(screen.queryByText("送信済みテスト2")).not.toBeInTheDocument();
      // 解除
      fireEvent.click(alreadyHandedCheckbox);
      expect(alreadyHandedCheckbox.checked).toBe(true);
      expect(screen.getByText("送信済みテスト")).toBeInTheDocument();
      expect(screen.getByText("送信済みテスト2")).toBeInTheDocument();

      // 入力済みをフィルター
      const filledOutCheckbox = screen.getByRole('checkbox', { name: '入力済み' }) as HTMLInputElement;
      fireEvent.click(filledOutCheckbox);
      expect(filledOutCheckbox.checked).toBe(false);
      expect(screen.queryByText("入力済みテスト")).not.toBeInTheDocument();
      expect(screen.queryByText("入力済みテスト2")).not.toBeInTheDocument();
      // 解除
      fireEvent.click(filledOutCheckbox);
      expect(filledOutCheckbox.checked).toBe(true);
      expect(screen.getByText("入力済みテスト")).toBeInTheDocument();
      expect(screen.getByText("入力済みテスト2")).toBeInTheDocument();


      // 入力中をフィルター
      const fillingInCheckbox = screen.getByRole('checkbox', { name: '入力中' }) as HTMLInputElement;
      fireEvent.click(fillingInCheckbox);
      expect(fillingInCheckbox.checked).toBe(false);
      expect(screen.queryByText("入力中テスト")).not.toBeInTheDocument();
      expect(screen.queryByText("入力中テスト2")).not.toBeInTheDocument();
      // 解除
      fireEvent.click(fillingInCheckbox);
      expect(fillingInCheckbox.checked).toBe(true);
      expect(screen.getByText("入力中テスト")).toBeInTheDocument();
      expect(screen.getByText("入力中テスト2")).toBeInTheDocument();;


      // 連携待ちをフィルター
      const waitingForLinkCheckbox = screen.getByRole('checkbox', { name: '連携待ち' }) as HTMLInputElement;
      fireEvent.click(waitingForLinkCheckbox);
      expect(waitingForLinkCheckbox.checked).toBe(false);
      expect(screen.queryByText("連携待ちテスト")).not.toBeInTheDocument();
      expect(screen.queryByText("連携待ちテスト2")).not.toBeInTheDocument();
      // 解除
      fireEvent.click(waitingForLinkCheckbox);
      expect(waitingForLinkCheckbox.checked).toBe(true);
      expect(screen.getByText("連携待ちテスト")).toBeInTheDocument();
      expect(screen.getByText("連携待ちテスト2")).toBeInTheDocument();


      // 連携済みをフィルター
      const alreadyLinkedCheckbox = screen.getByRole('checkbox', { name: '連携済み' }) as HTMLInputElement;
      fireEvent.click(alreadyLinkedCheckbox);
      expect(alreadyLinkedCheckbox.checked).toBe(false);
      expect(screen.queryByText("連携済みテスト")).not.toBeInTheDocument();
      expect(screen.queryByText("連携済みテスト2")).not.toBeInTheDocument();
      // 解除
      fireEvent.click(alreadyLinkedCheckbox);
      expect(alreadyLinkedCheckbox.checked).toBe(true);
      expect(screen.getByText("連携済みテスト")).toBeInTheDocument();
      expect(screen.getByText("連携済みテスト2")).toBeInTheDocument();;

      // ソートの確認(各ステータスのフィルターを全て解除した後で初めに用意した順番になっていればOK)
      const tbody = container.querySelector('tbody');
      expect(tbody.children[0].id).toBe("d-interview-detail9");
      expect(tbody.children[1].id).toBe("d-interview-detail10");
      expect(tbody.children[2].id).toBe("d-interview-detail1");
      expect(tbody.children[3].id).toBe("d-interview-detail2");
      expect(tbody.children[4].id).toBe("d-interview-detail3");
      expect(tbody.children[5].id).toBe("d-interview-detail4");
      expect(tbody.children[6].id).toBe("d-interview-detail5");
      expect(tbody.children[7].id).toBe("d-interview-detail6");
      expect(tbody.children[8].id).toBe("d-interview-detail7");
      expect(tbody.children[9].id).toBe("d-interview-detail8");
    });
  });

  describe('display-filter works', () => {
    test('renders expected content', () => {
      // 各ステータスのうち片方を非表示(display_flgが0)にする
      const dInterviewDetails = [
        { // 入力中患者1人目
          id: 1,
          m_patient_id: null,
          status: 2,
          kanzyano: "",
          d_sheet_id: 1,
          name: "入力中テスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 入力済み患者1人目
          id: 3,
          m_patient_id: null,
          status: 1,
          kanzyano: "",
          d_sheet_id: 3,
          name: "入力済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携待ち患者1人目
          id: 5,
          m_patient_id: 1,
          status: 3,
          kanzyano: "A12345",
          d_sheet_id: 5,
          name: "連携待ちテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携済み患者1人目
          id: 7,
          m_patient_id: 3,
          status: 4,
          kanzyano: "C12345",
          d_sheet_id: 7,
          name: "連携済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 送信済み患者1人目
          id: 9,
          m_patient_id: null,
          status: 0,
          kanzyano: "",
          d_sheet_id: 9,
          name: "送信済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: null,
          is_leftover_medicine: null,
          is_question: null,
          display_flg: 1
        }
      ]

      const allDInterviewDetails  = [
        { // 入力中患者1人目
          id: 1,
          m_patient_id: null,
          status: 2,
          kanzyano: "",
          d_sheet_id: 1,
          name: "入力中テスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        }, 
        { // 入力中患者2人目
          id: 2,
          m_patient_id: null,
          status: 2,
          kanzyano: "",
          d_sheet_id: 2,
          name: "入力中テスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 0
        },
        { // 入力済み患者1人目
          id: 3,
          m_patient_id: null,
          status: 1,
          kanzyano: "",
          d_sheet_id: 3,
          name: "入力済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 入力済み患者2人目
          id: 4,
          m_patient_id: null,
          status: 1,
          kanzyano: "",
          d_sheet_id: 4,
          name: "入力済みテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 0
        },
        { // 連携待ち患者1人目
          id: 5,
          m_patient_id: 1,
          status: 3,
          kanzyano: "A12345",
          d_sheet_id: 5,
          name: "連携待ちテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携待ち患者2人目
          id: 6,
          m_patient_id: 2,
          status: 3,
          kanzyano: "B12345",
          d_sheet_id: 6,
          name: "連携待ちテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 0
        },
        { // 連携済み患者1人目
          id: 7,
          m_patient_id: 3,
          status: 4,
          kanzyano: "C12345",
          d_sheet_id: 7,
          name: "連携済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: new Date("2022-01-31 11:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        },
        { // 連携済み患者2人目
          id: 8,
          m_patient_id: 4,
          status: 4,
          kanzyano: "D12345",
          d_sheet_id: 8,
          name: "連携済みテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: new Date("2022-01-31 10:00:00.000000"),
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 0
        },
        { // 送信済み患者1人目
          id: 9,
          m_patient_id: null,
          status: 0,
          kanzyano: "",
          d_sheet_id: 9,
          name: "送信済みテスト",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 11:00:00.000000"),
          start_at: null,
          is_leftover_medicine: null,
          is_question: null,
          display_flg: 1
        },
        { // 送信済み患者2人目
          id: 10,
          m_patient_id: null,
          status: 0,
          kanzyano: "",
          d_sheet_id: 10,
          name: "送信済みテスト2",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: new Date("2022-01-31 10:00:00.000000"),
          start_at: null,
          is_leftover_medicine: null,
          is_question: null,
          display_flg: 0
        }
      ]
      const { container } = render(<Index d_interview_details={dInterviewDetails} all_d_interview_details={allDInterviewDetails} m_institution={m_institution}/>);

      // screen.debug();

      // 非表示を含める前に非表示以外のデータがあることを確認
      expect(screen.getByText('入力中テスト')).toBeInTheDocument();
      expect(screen.getByText('入力済みテスト')).toBeInTheDocument();
      expect(screen.getByText('連携待ちテスト')).toBeInTheDocument();
      expect(screen.getByText('連携済みテスト')).toBeInTheDocument();
      expect(screen.getByText('送信済みテスト')).toBeInTheDocument();

      //  非表示を含める
      const displayCheckbox = screen.getByRole('checkbox', { name: '非表示を含める' }) as HTMLInputElement;
      fireEvent.click(displayCheckbox);
      expect(displayCheckbox.checked).toBe(true);
      expect(screen.getByText('入力中テスト')).toBeInTheDocument();
      expect(screen.getByText('入力中テスト2')).toBeInTheDocument();
      expect(screen.getByText('入力済みテスト')).toBeInTheDocument();
      expect(screen.getByText('入力済みテスト2')).toBeInTheDocument();
      expect(screen.getByText('連携待ちテスト')).toBeInTheDocument();
      expect(screen.getByText('連携待ちテスト2')).toBeInTheDocument();
      expect(screen.getByText('連携済みテスト')).toBeInTheDocument();
      expect(screen.getByText('連携済みテスト2')).toBeInTheDocument();
      expect(screen.getByText('送信済みテスト')).toBeInTheDocument();
      expect(screen.getByText('送信済みテスト2')).toBeInTheDocument();

      // ソートの確認
      const tbody = container.querySelector('tbody');
      expect(tbody.children[0].id).toBe("d-interview-detail9");
      expect(tbody.children[1].id).toBe("d-interview-detail10");
      expect(tbody.children[2].id).toBe("d-interview-detail1");
      expect(tbody.children[3].id).toBe("d-interview-detail2");
      expect(tbody.children[4].id).toBe("d-interview-detail3");
      expect(tbody.children[5].id).toBe("d-interview-detail4");
      expect(tbody.children[6].id).toBe("d-interview-detail5");
      expect(tbody.children[7].id).toBe("d-interview-detail6");
      expect(tbody.children[8].id).toBe("d-interview-detail7");
      expect(tbody.children[9].id).toBe("d-interview-detail8");
    });
  });

  describe('date-change works', () => {
    test('renders expected content', async() => {
      let date = new Date();
      const dInterviewDetails = [
        { // 当日分の患者
          id: 1,
          m_patient_id: null,
          status: 2,
          kanzyano: "",
          d_sheet_id: 1,
          name: "患者A",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: date,
          start_at: date,
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        }
      ]

      const allDInterviewDetails = [
        { // 当日分の患者
          id: 1,
          m_patient_id: null,
          status: 2,
          kanzyano: "",
          d_sheet_id: 1,
          name: "患者A",
          is_new_patient: true,
          nupdatef: 0,
          bupdatef: 0,
          birthday: "1999-03-12",
          created_at: date,
          start_at: date,
          is_leftover_medicine: true,
          is_question: true,
          display_flg: 1
        }
      ]

      const mock_yesterday_dInterviewDetails = Promise.resolve({
        data: {
          d_interview_details: [{
            id: 2,
            m_patient_id: null,
            status: 2,
            kanzyano: "",
            d_sheet_id: 2,
            name: "患者B",
            is_new_patient: true,
            nupdatef: 0,
            bupdatef: 0,
            birthday: "1999-03-12",
            created_at: new Date(date.setDate(date.getDate() - 1)),
            start_at: new Date(date.setDate(date.getDate() - 1)),
            is_leftover_medicine: true,
            is_question: true,
            display_flg: 1
          }],
          all_d_interview_details: [{
            id: 2,
            m_patient_id: null,
            status: 2,
            kanzyano: "",
            d_sheet_id: 2,
            name: "患者B",
            is_new_patient: true,
            nupdatef: 0,
            bupdatef: 0,
            birthday: "1999-03-12",
            created_at: new Date(date.setDate(date.getDate() - 1)),
            start_at: new Date(date.setDate(date.getDate() - 1)),
            is_leftover_medicine: true,
            is_question: true,
            display_flg: 1
          }],
          previous_date: date.setDate(date.getDate() - 1)
        }
      });

      const mock_selectedDay_dInterviewDetails = Promise.resolve({
        data: {
          d_interview_details: [{
            id: 3,
            m_patient_id: null,
            status: 1,
            kanzyano: "",
            d_sheet_id: 3,
            name: "患者C",
            is_new_patient: true,
            nupdatef: 0,
            bupdatef: 0,
            birthday: "1999-03-12",
            created_at: new Date("2022-01-01 11:00:00.000000"),
            start_at: new Date("2022-01-01 11:00:00.000000"),
            is_leftover_medicine: true,
            is_question: true,
            display_flg: 1
          }],
          all_d_interview_details: [{
            id: 3,
            m_patient_id: null,
            status: 1,
            kanzyano: "",
            d_sheet_id: 3,
            name: "患者C",
            is_new_patient: true,
            nupdatef: 0,
            bupdatef: 0,
            birthday: "1999-03-12",
            created_at: new Date("2022-01-01 11:00:00.000000"),
            start_at: new Date("2022-01-01 11:00:00.000000"),
            is_leftover_medicine: true,
            is_question: true,
            display_flg: 1
          }]
        }
      });

      const mock_today_dInterviewDetails = Promise.resolve({
        data: {
          d_interview_details: [{
            id: 1,
            m_patient_id: null,
            status: 2,
            kanzyano: "",
            d_sheet_id: 1,
            name: "患者A",
            is_new_patient: true,
            nupdatef: 0,
            bupdatef: 0,
            birthday: "1999-03-12",
            created_at: date,
            start_at: date,
            is_leftover_medicine: true,
            is_question: true,
            display_flg: 1
          }],
          all_d_interview_details: [{
            id: 1,
            m_patient_id: null,
            status: 2,
            kanzyano: "",
            d_sheet_id: 1,
            name: "患者A",
            is_new_patient: true,
            nupdatef: 0,
            bupdatef: 0,
            birthday: "1999-03-12",
            created_at: date,
            start_at: date,
            is_leftover_medicine: true,
            is_question: true,
            display_flg: 1
          }]
        }
      });

      (axios.get as any)
      .mockReturnValueOnce(mock_yesterday_dInterviewDetails)
      .mockReturnValueOnce(mock_today_dInterviewDetails)
      .mockReturnValueOnce(mock_yesterday_dInterviewDetails)
      .mockReturnValueOnce(mock_today_dInterviewDetails)
      .mockReturnValueOnce(mock_selectedDay_dInterviewDetails);

      const { container } = render(<Index d_interview_details={dInterviewDetails} all_d_interview_details={allDInterviewDetails} m_institution={m_institution}/>);

      await act(() => mock_today_dInterviewDetails);
      await act(() => mock_yesterday_dInterviewDetails);
      await act(() => mock_selectedDay_dInterviewDetails);

      // 当日分の患者が表示されていることを確認
      expect(screen.getByText("患者A"));
      // 一日前を表示
      const previousDayButton = screen.getByRole('button', { name: "<" });
      fireEvent.click(previousDayButton);
      expect(await screen.findByText('患者B')).toBeInTheDocument();
      expect(await screen.findByText('今日')).toBeInTheDocument();
      // 日付を変更した時に各フィルターが初期化されているか確認する
      const alreadyHandedCheckbox = await screen.getByRole('checkbox', { name: '送信済み' }) as HTMLInputElement;
      const filledOutCheckbox = await screen.getByRole('checkbox', { name: '入力済み' }) as HTMLInputElement;
      const fillingInCheckbox = await screen.getByRole('checkbox', { name: '入力中' }) as HTMLInputElement;
      const waitingForLinkCheckbox = await screen.getByRole('checkbox', { name: '連携待ち' }) as HTMLInputElement;
      const alreadyLinkedCheckbox = await screen.getByRole('checkbox', { name: '連携済み' }) as HTMLInputElement;
      const displayCheckbox = await screen.getByRole('checkbox', { name: '非表示を含める' }) as HTMLInputElement;

      expect(alreadyHandedCheckbox.checked).toBe(true);
      expect(filledOutCheckbox.checked).toBe(true);
      expect(fillingInCheckbox.checked).toBe(true);
      expect(waitingForLinkCheckbox.checked).toBe(true);
      expect(alreadyLinkedCheckbox.checked).toBe(true);
      expect(displayCheckbox.checked).toBe(false);
      // 翌日を表示
      const nextDayButton = screen.getByRole('button', { name: ">" });
      fireEvent.click(nextDayButton);
      expect(await screen.findByText('患者A')).toBeInTheDocument();
      expect(alreadyHandedCheckbox.checked).toBe(true);
      expect(filledOutCheckbox.checked).toBe(true);
      expect(fillingInCheckbox.checked).toBe(true);
      expect(waitingForLinkCheckbox.checked).toBe(true);
      expect(alreadyLinkedCheckbox.checked).toBe(true);
      expect(displayCheckbox.checked).toBe(false);
      // 「今日」ボタンを押すために再び一日前を表示
      fireEvent.click(previousDayButton);
      expect(await screen.findByText('患者B')).toBeInTheDocument();
      expect(await screen.findByText('今日')).toBeInTheDocument();
      // 当日分を表示
      const todayButton = screen.getByRole('button', { name: "今日" });
      fireEvent.click(todayButton);
      expect(await screen.findByText('患者A')).toBeInTheDocument();
      expect(alreadyHandedCheckbox.checked).toBe(true);
      expect(filledOutCheckbox.checked).toBe(true);
      expect(fillingInCheckbox.checked).toBe(true);
      expect(waitingForLinkCheckbox.checked).toBe(true);
      expect(alreadyLinkedCheckbox.checked).toBe(true);
      expect(displayCheckbox.checked).toBe(false);
      // 日付入力欄に2022年1月1日を入力し、患者Cを表示
      const inputDate = container.querySelector('.date-select-field') as HTMLInputElement;
      fireEvent.change(inputDate, {target: {value: '2022-01-01'}})
      expect(await screen.findByText('患者C')).toBeInTheDocument();
      expect(alreadyHandedCheckbox.checked).toBe(true);
      expect(filledOutCheckbox.checked).toBe(true);
      expect(fillingInCheckbox.checked).toBe(true);
      expect(waitingForLinkCheckbox.checked).toBe(true);
      expect(alreadyLinkedCheckbox.checked).toBe(true);
      expect(displayCheckbox.checked).toBe(false);

      // await screen.debug();
    });
  });
});
